export enum UserAttributeType {
  Sleep = 'Sleep',
  BloodGlucose = 'Blood Glucose',
  BloodPressure = 'Blood Pressure',
  Steps = 'Steps',
  HeartRateVariability = 'Heart Rate Variability',
  HeartRate = 'Heart Rate',
  OxygenSaturation = 'Oxygen Saturation',
  RestingHeartRate = 'Resting Heart Rate',
  BodyTemperature = 'Body Temperature',
  CaloriesBurned = 'Calories Burned',
  CaloriesConsumed = 'Calories Consumed',
  BodyMassIndex = 'Body Mass Index',
  BodyFatPercentage = 'Body Fat Percentage',
  Weight = 'Weight',
  ActiveEnergyBurned = 'Active Energy Burned',
  BasalEnergyBurned = 'Basal Energy Burned',
  BloodAlcoholContent = 'Blood Alcohol Content',
  Carbohydrates = 'Carbohydrates',
  EnergyConsumed = 'Energy Consumed',
  Height = 'Height',
  LeanBodyMass = 'Lean Body Mass',
  ProteinConsumed = 'Protein Consumed',
  TotalFatConsumed = 'Total Fat Consumed'
}

export enum OuraSpecificDataType {
  RespiratoryRate = 'Respiratory Rate',
  LowestHeartRate = 'Lowest Heart Rate',
  SleepEfficiency = 'Sleep Efficiency',
  AwakeTime = 'Awake Time',
  DeepSleepDuration = 'Deep Sleep Duration',
  SleepLatency = 'Sleep Latency',
  LightSleepDuration = 'Light Sleep Duration',
  REMSleepDuration = 'REM Sleep Duration',
  TemperatureDeviation = 'Temperature Deviation',
  TemperatureTrendDeviation = 'Temperature Trend Deviation',
  ActiveCalories = 'Active Calories',
  HighActivityTime = 'High Activity Time',
  LowActivityTime = 'Low Activity Time',
  NonWearTime = 'Non-wear Time',
  SedentaryTime = 'Sedentary Time',
  Spo2NightlyDisturbances = 'SPO2 Nightly Disturbances',
  Workout = 'Workout'
}

export enum UserAttributeSource {
  HealthKit = 'HealthKit',
  HealthConnect = 'Health Connect',
  GoogleFit = 'Google Fit',
  Fitbit = 'Fitbit',
  Garmin = 'Garmin',
  Oura = 'Oura'
}

export interface UserAttribute {
  id?: number;
  userId: number;
  startDate: Date;
  endDate: Date;
  type: UserAttributeType;
  source?: UserAttributeSource;
  subSource?: string;
  unit?: string;
  textValue?: string;
  numberValue?: number;
  booleanValue?: boolean;
  jsonValue?: any;
  deviceId?: string;
  created?: Date;
  inputType?: UserAttributeInputType;
  sourceName?: string;
}

export enum UserAttributeInputType {
  Manual = 'Manual',
  Wearable = 'Wearable'
}
